<script>
	// NPM Modules
	import { navigate } from 'svelte-navaid';
	// Stores
	import MarketGroupSetStore from '@/Stores/Sport/MarketGroupSetStore.js';
	// Services
	import { getUrlParameter, setUrlParameter, paginationBuilder } from '@/Services/Helpers.js';
	// Components
	import Loading from '@/Components/Loading.svelte';
	import Icon from '@/Components/Icon.svelte';
	import Pagination from '@/Components/Pagination.svelte';
	import CheckBox from '@/Components/CheckBox.svelte';

	export let sportId;

	MarketGroupSetStore.resetStore();

	$: links =
		$MarketGroupSetStore &&
		!$MarketGroupSetStore.id &&
		$MarketGroupSetStore.id !== null &&
		paginationBuilder(MarketGroupSetStore.getPagination());
	$: sportId && getMarketGroupSets();

	let pageNo = getUrlParameter('page') || 1;
	let loading;

	function changePage(e) {
		if (e) {
			pageNo = e.detail.page;
			getMarketGroupSets();
			setUrlParameter('page', pageNo);
		}
	}

	function getMarketGroupSets() {
		loading = MarketGroupSetStore.getMarketGroupSetsForSport(sportId, {
			size: 50,
			number: pageNo
		});
	}

	function click(id) {
		navigate(`/sport/markets/group-sets/${id}?sport=${sportId}`);
	}
</script>

{#await loading}
	<Loading />
{:then}
	<div class="overflow-x-auto rounded">
		<table class="w-full whitespace-nowrap">
			<thead>
				<tr class="text-xs text-left text-gray-500 uppercase">
					<th class="px-6 pt-5 pb-4 font-medium">Market Group Set</th>
					<th class="w-16 px-6 pt-5 pb-4 font-medium">Sport</th>
					<th class="w-16 px-6 pt-5 pb-4 font-medium">Default</th>
					<th class="w-px px-6 pt-5 pb-4 font-medium" />
				</tr>
			</thead>
			<tbody class="bg-white">
				{#each $MarketGroupSetStore.sortBy('order').all() as marketGroup (marketGroup.id)}
					<tr on:click={() => click(marketGroup.id)} class="cursor-pointer hover:bg-gray-100 focus-within:bg-gray-100">
						<td class="p-4 px-6 border-t">
							<div class="flex items-center">
								<div class="mr-2 font-semibold">{marketGroup.name}</div>
							</div>
						</td>
						<td class="p-4 px-6 border-t">
							<div class="px-2 py-1 bg-green-500 rounded-md text-light">
								{marketGroup.sport.name || '-'}
							</div>
						</td>
						<td class="w-px px-6 border-t text-center">
							<CheckBox center={true} disabled bind:checked={marketGroup.is_default} />
						</td>
						<td class="w-px px-6 border-t">
							<Icon name="chevron-right" classes="block w-4 h-4 text-gray-400 inline" />
						</td>
					</tr>
				{:else}
					<tr>
						<td class="px-6 py-4 text-center border-t" colspan="4"> No market group sets found. </td>
					</tr>
				{/each}
			</tbody>
		</table>
	</div>
	<Pagination {links} on:click={changePage} className="my-3" />
{/await}
